import { useState } from "react";
import React = require("react");
import { PublicAmorgUser } from '../../../amorg-common';
import { MessageCard } from "../../../designSystem/Message";
import { H2 } from "../../../designSystem/typography/Heading";
import { ButtonRow } from "../../../designSystem/button/ButtonRow";
import { TextField } from "../../../designSystem/formField/text/TextField";
import { Button } from "../../../designSystem/button/Button";
import { adminUpdateEmail, requestNewEmail } from "../../../api/userClientApi";
import { fieldValidation } from '../../../amorg-common';
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { TooltipWrapper } from "../../../designSystem/TooltipWrapper";
import { Icon } from "../../../designSystem/icons/Icons";


type EmailEditorProps = {
    siteId: string,
    selectedUser: PublicAmorgUser;
    isAdmin: boolean;
};
type ResultStatus = 'none' | 'error' | 'success';
type EmailState = {
    value: string;
    isValid: boolean;
};
export function EmailEditor ({ selectedUser, siteId, isAdmin }: EmailEditorProps): JSX.Element
{
    const [status, setStatus] = useState<ResultStatus>('none');
    const [message, setMessage] = useState('');
    const [email, setEmail] = useState<EmailState>({ value: selectedUser.email, isValid: false });

    const handleOnClick = async () =>
    {
        const result = isAdmin
            ? await adminUpdateEmail(
                selectedUser.id,
                email.value
            )
            : await requestNewEmail(
                siteId,
                selectedUser.id,
                email.value
            );
        if (result.isSuccess)
        {
            setStatus('success');
            if (isAdmin)
                setMessage('E-mail addressen er opdateret.');
            else
                setMessage('Vi har sendt en e-mail til den indtastede e-mail address. Følg vejledningen for at gennemføre ændringen.');
        }
        else
        {
            setStatus('error');
            setMessage('Din e-mail adresse kunne ikke ændres. Dette kan skyldes at den indtastede adresse er i brug, eller at det indtastede e-maildomæne ikke er gyldigt.');
        }
    };

    const handleOnChange = (value: string) =>
    {
        const isValid = fieldValidation.user.email(value);

        if (status !== 'success')
        {
            setStatus('none');
            setMessage('');
            setEmail({ value, isValid: isValid && value !== selectedUser.email });
        }
    };

    return (
        <Flex flexDirection="column" gap={8}>
            {isAdmin
                ? <div>
                    <TooltipWrapper tooltip="Som administrator kan du skifte en brugers e-mail">
                        <Flex flexDirection="row" justifyContent="space-between">
                            <H2>Skift e-mail</H2>
                            <Icon name="survey_question" />
                        </Flex>
                    </TooltipWrapper>
                </div>
                : <H2>Skift e-mail</H2>
            }

            {status !== 'none' &&
                <MessageCard variant={status}>{message}</MessageCard>
            }
            <TextField
                label="E-mail"
                value={email.value}
                onChange={handleOnChange}
                validator={() => { return { valid: true }; }}
                autoComplete="on"
                disabled={!selectedUser.enabled} />

            <ButtonRow variant="right-aligned">
                <Button variant="outlined"
                    disabled={status === 'success' || !email.isValid || !selectedUser.enabled}
                    onClick={handleOnClick}
                    text={"Skift e-mail"} />
            </ButtonRow>
        </Flex>
    );
}